import { render, staticRenderFns } from "./BaseRimconfigCardCarSelector.vue?vue&type=template&id=7353303a"
import script from "./BaseRimconfigCardCarSelector.vue?vue&type=script&lang=js"
export * from "./BaseRimconfigCardCarSelector.vue?vue&type=script&lang=js"
import style0 from "./BaseRimconfigCardCarSelector.vue?vue&type=style&index=0&id=7353303a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports